import { createApp, h } from 'vue';
import { createInertiaApp, Head, Link } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import { VueReCaptcha } from 'vue-recaptcha-v3';
// import axios from 'axios'; // import Axios

createInertiaApp({
  resolve: (name) => require(`./Pages/${name}`),
  setup({ el, app, props, plugin }) {
    const appInstance = createApp({ render: () => h(app, props) })
      .use(plugin)
      .use(VueReCaptcha, {
        siteKey: process.env.MIX_RECAPTCHAV3_SITEKEY
      })
      // global components
      .component('Head', Head)
      .component('Link', Link);
    // register Axios globally
    // appInstance.config.globalProperties.$axios = axios;
    // filters
    appInstance.config.globalProperties.$filters = {
      media_path: function (value) {
        return '../../../media/' + value;
      },
      public_path: function (value) {
        return '../../../frontend/img/' + value;
      },

      base_url: function (value) {
        return '/creator/' + value;
      },
      nl2br: function (value) {
        var breakTag = '<br>';
        return (value + '').replace(
          /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
          '$1' + breakTag + '$2'
        );
      },
      truncate: function (text, length, clamp) {
        clamp = clamp || '...';
        var node = document.createElement('div');
        node.innerHTML = text;
        var content = node.textContent;
        return content.length > length
          ? content.slice(0, length) + clamp
          : content;
      }
    };
    // mount appInstance
    appInstance.mount(el);
  }
});

InertiaProgress.init({
  delay: 250,

  color: '#29d',

  includeCSS: true,

  showSpinner: true
});
